const pt = {
  // Navigation
  nav_home: "In\u00edcio",
  nav_explore: "Explorar",
  nav_workspace: "Espaço de trabalho",
  ws_videos: "vídeos",
  ws_untitled: "Vídeo sem título",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "Falha no vídeo",
  ws_failed_refunded: "Seu crédito foi devolvido",
  ws_failed_dismiss: "Liberar",
  ws_failed_retry: "Tente novamente",
  ws_failed_retrying: "Começando…",
  ws_failed_banner_one: "Não foi possível gerar um vídeo",
  ws_failed_banner_many: "{n} vídeos falharam",
  ws_failed_banner_body: "Nada foi cobrado – o crédito voltou para sua conta. Tente novamente ou escolha um tópico diferente.",
  ws_empty_title: "Nada aqui ainda.",
  ws_empty_body: "Cada vídeo que você fizer aparecerá aqui, o mais recente primeiro.",
  ws_generate: "Gerar",
  ws_composer_placeholder: "Descreva uma lição\u2026",
  ws_placeholder_hw: "Dê um nome à tarefa… (opcional)",
  ws_placeholder_lecture: "Dê um nome à palestra… (opcional)",
  ws_placeholder_self_study: "O que você quer estudar?",
  nav_search: "Buscar v\u00eddeos...",
  nav_search_yours: "Pesquise seus vídeos...",
  nav_notifications: "Notifica\u00e7\u00f5es",
  nav_mark_all_read: "Marcar tudo como lido",
  nav_no_notifications: "Nenhuma notifica\u00e7\u00e3o ainda",
  nav_no_notifications_sub: "Vamos te avisar quando seus v\u00eddeos estiverem prontos",
  nav_upgrade: "Melhorar plano",
  nav_billing: "Faturamento",
  nav_settings: "Configura\u00e7\u00f5es",
  nav_contact: "Fale conosco",
  nav_api: "API",
  nav_sign_out: "Sair",
  nav_just_now: "Agora mesmo",
  nav_minutes_ago: "{n}m atr\u00e1s",
  nav_hours_ago: "{n}h atr\u00e1s",
  nav_days_ago: "{n}d atr\u00e1s",
  nav_used_this_month: "{used} de {cap} usados este m\u00eas",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "{used} de {limit} usado esta semana",
  nav_free_daily: "4 vídeos gratuitos por semana",
  // Settings
  settings_title: "Configura\u00e7\u00f5es",
  settings_profile: "Perfil",
  settings_change_avatar: "Mudar avatar",
  settings_cancel: "Cancelar",
  settings_choose_wizard: "Escolha seu mago",
  settings_display_name: "Nome de exibi\u00e7\u00e3o",
  settings_your_name: "Seu nome",
  settings_save: "Salvar",
  settings_saving: "Salvando...",
  settings_saved: "Salvo",
  settings_save_failed: "Falha ao salvar",
  settings_email: "E-mail",
  settings_notifications: "Notifica\u00e7\u00f5es",
  settings_email_notif: "Notifica\u00e7\u00f5es por e-mail",
  settings_email_notif_desc: "Receba atualiza\u00e7\u00f5es e an\u00fancios por e-mail",
  settings_language: "Idioma",
  settings_language_desc: "Escolha o idioma do app e da narra\u00e7\u00e3o dos v\u00eddeos",
  settings_data_title: "Seus dados",
  settings_data_desc: "Baixe uma cópia dos dados pessoais associados à sua conta – incluindo seu perfil, vídeos, cursos, sessões e mensagens de suporte. Os logs internos do sistema e os dados de processamento derivados não estão incluídos.",
  settings_data_download: "Baixar meus dados",
  settings_data_exporting: "Preparando…",
  settings_danger: "Zona de perigo",
  settings_delete_account: "Excluir conta",
  settings_delete_desc: "Exclua permanentemente sua conta e todos os dados associados. Esta a\u00e7\u00e3o n\u00e3o pode ser desfeita.",
  settings_delete_confirm: "Isso excluir\u00e1 permanentemente sua conta e todos os seus dados. Digite {keyword} para confirmar.",
  settings_delete_placeholder: "Digite \"DELETE\" para confirmar",
  settings_permanently_delete: "Excluir permanentemente",
  settings_deleting: "Excluindo...",
  explore_watch_now: "Assistir agora",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "Sem pr\u00e9via",
  explore_no_videos: "Nenhum v\u00eddeo dispon\u00edvel ainda. Volte em breve!",
  explore_featured_courses: "Cursos em destaque",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "Voltar para explorar",
  course_not_found: "Este curso não está disponível.",
  // Home Page
  home_hero: "Aprenda qualquer coisa, ",
  home_hero_accent: "visualmente",
  home_placeholder: "O que voc\u00ea quer aprender ou resolver?",
  home_extracting: "Extraindo perguntas...",
  home_videos_generated: "{n, plural, one {# v\u00eddeo} other {# v\u00eddeos}} ser\u00e3o gerados",
  home_credits: "{n, plural, one {# cr\u00e9dito} other {# cr\u00e9ditos}}",
  home_remaining: "restantes este m\u00eas",
  home_enter_prompt: "Por favor, insira o que voc\u00ea quer aprender ou resolver",
  home_popular: "Li\u00e7\u00f5es populares",
  home_from_community: "Da comunidade",
  home_community_sub: "Veja o que os estudantes est\u00e3o criando",
  home_tips_label: "Do mago mago",
  home_tips_title: "Dicas e truques",
  home_tip1_title: "Seja específico",
  home_tip1_desc: "Não digite um assunto inteiro. Escolha uma ideia, um conceito, uma pergunta.",
  home_tip1_example: "Como funciona a replicação do DNA em células eucarióticas",
  home_tip2_title: "Diga para quem é",
  home_tip2_desc: "Uma explicação no ensino médio parece completamente diferente de uma palestra na faculdade.",
  home_tip2_example: "Explique derivadas para alguém que acabou de aprender álgebra",
  home_tip3_title: "Diga aos Magos o que você quer",
  home_tip3_desc: "Exemplos, aplicações passo a passo do mundo real - basta dizer e os Magos o seguirão.",
  home_tip3_example: "O ciclo da água com exemplos reais e um resumo",
  home_tip_try: "Tente algo como",
  home_proven_social: "Siga-nos no Instagram",
  home_ig_desc_1: "Mais de ",
  home_ig_followers: "55.000 seguidores",
  home_ig_desc_2: "assista nossos vídeos de matemática e ciências no Instagram todos os dias. Essas bobinas são feitas com o mesmo motor que você usa aqui.",
  home_view_profile: "Ver perfil",
  home_subscribe_now: "Assine agora",
  home_sub_monthly: "Mensal",
  home_sub_yearly: "Anual",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "Economize {pct}%",
  home_sub_per_month: "/ m\u00eas",
  home_sub_billed_monthly: "faturado em ${amount} todos os meses",
  home_sub_processing: "Processando...",
  home_sub_no_commitment: "Sem compromisso. Cancele a qualquer momento.",
  home_sub_secured: "Protegido pelo Stripe",
  home_sub_headline: "Desbloqueie mais com {plan}",
  home_sub_due_now: "Vencimento agora",
  home_sub_trial_label: "{days}-dias de acesso total",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "Você receberá uma cobrança de US${amount} hoje por {n} vídeos neste mês. Em {date}, ele será renovado por US${amount}/mês, a menos que você cancele primeiro. Cancele a qualquer momento no Faturamento.",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "Serão cobrados ${trial} hoje por {days} dias de acesso total, limitado a {n} vídeos. A avaliação não continua em ${trial} — em {date} ela se torna automaticamente {planName} a ${plan} por mês (vídeos {full}) e ${plan} será cobrado todos os meses depois disso até você cancelar. Cancele a qualquer momento do faturamento.",
  home_sub_card: "Cartão de crédito ou débito",
  home_sub_billed_once_yearly: "faturado em ${amount} uma vez por ano",
  home_sub_billed_trial: "faturado em ${amount} por {days} dias e depois renovado por ${renews} todos os meses",
  home_sub_switch_plan: "Procurando por {plan}?",
  home_sub_replaces_plan: "Substitui seu plano {plan}. Sua data de faturamento permanece a mesma – a mudança para cima cobra a diferença agora, a mudança para baixo começa na próxima renovação.",
  home_sub_change_now: "Já está no {plan} — foram cobrados {amount} pela diferença.",
  home_sub_change_later: "Vai passar para {plan} em {date}. Nada é cobrado hoje.",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "{n} v\u00eddeos por m\u00eas",
  // Pricing Page
  pricing_title: "Melhore seu plano",
  pricing_monthly: "Mensal",
  pricing_yearly: "Anual",
  pricing_save: "Economize 17%",
  pricing_best_value: "Melhor valor",
  pricing_your_plan: "Seu plano atual",
  pricing_get_started: "Come\u00e7ar",
  pricing_processing: "Processando...",
  pricing_per_month: "/m\u00eas",
  pricing_billed_yearly: "Cobrado ${amount}/ano",
  pricing_videos_month: "{n, plural, one {# v\u00eddeo} other {# v\u00eddeos}}/m\u00eas",
  pricing_manage_cancel: "Gerenciar ou cancelar",
  pricing_manage_unavailable: "Não encontrámos uma subscrição para gerir. Contacte-nos e resolvemos.",
  pricing_opening: "Abrindo...",
  billing_autorenew_monthly: "Renova automaticamente por ${amount}/mês até você cancelar.",
  billing_autorenew_yearly: "Renova automaticamente por ${amount}/ano até você cancelar.",
  billing_autorenews_on: "Renovação automática em {date} · cancele a qualquer momento",
  pricing_secured: "Protegido pelo Stripe",
  pricing_login_required: "Fa\u00e7a login para assinar",
  pricing_auth_error: "Erro de autentica\u00e7\u00e3o. Por favor, saia e entre novamente.",
  pricing_feature_pdf: "Extra\u00e7\u00e3o de PDF e imagens",
  pricing_feature_quality: "Modelo de maior qualidade",
  pricing_feature_speed: "Gera\u00e7\u00e3o mais r\u00e1pida",
  pricing_feature_study: "Sess\u00f5es de estudo",
  pricing_free_hint: "Atualmente no plano Gratuito",
  // Billing Page
  billing_title: "Faturamento",
  billing_current_plan: "Plano atual",
  billing_payment_failed_title: "Seu plano está pausado",
  billing_payment_failed_body: "Não foi possível coletar {amount}, então seu plano está pausado. Atualize seu cartão para reiniciá-lo. Também continuaremos tentando novamente.",
  billing_payment_failed_cta: "Resolver o pagamento",
  billing_change_plan: "Mudar plano",
  billing_invoices: "Faturas",
  billing_loading: "Carregando faturas...",
  billing_no_invoices: "Nenhuma fatura ainda",
  billing_date: "Data",
  billing_amount: "Valor",
  billing_status: "Status",
  billing_invoice: "Fatura",
  billing_view: "Ver",
  // Contact Page
  contact_title: "Fale conosco",
  contact_placeholder: "Como podemos ajudar?",
  contact_sent_desc: "Responderemos o mais r\u00e1pido poss\u00edvel.",
  contact_signin: "Faça login para entrar em contato com o suporte.",
  // Generation Queue
  queue_title: "Fila",
  queue_active: "{n} ativos",
  queue_generating: "{n} gerando",
  queue_ready: "Pronto para assistir",
  queue_in_queue: "Aguardando na fila...",
  queue_almost_ready: "Quase pronto...",
  queue_seconds_left: "{n}s restantes",
  queue_minutes_left: "{m}m {s}s restantes",
  queue_watch_now: "Assistir agora",
  queue_waiting: "Aguardando na fila...",
  queue_empty: "Nenhum v\u00eddeo na fila",
  queue_empty_sub: "Gere um v\u00eddeo para v\u00ea-lo aqui",
  queue_clear: "Limpar tudo",
  queue_total: "{n} total",
  queue_first_time: "Seu v\u00eddeo est\u00e1 sendo gerado",
  queue_first_time_sub: "Geralmente ~2 min. Voc\u00ea ouvir\u00e1 um som quando estiver pronto.",
  // Session Expired
  session_expired: "Sess\u00e3o expirada",
  session_expired_desc: "Sua sess\u00e3o expirou por motivos de seguran\u00e7a. Por favor, entre novamente para continuar.",
  // Cookie Banner
  cookie_text: "Usamos cookies para analisar o tr\u00e1fego do site e melhorar sua experi\u00eancia. Apenas cookies essenciais s\u00e3o definidos por padr\u00e3o.",
  cookie_learn_more: "Saiba mais",
  cookie_accept: "Aceitar todos",
  cookie_reject: "Rejeitar n\u00e3o essenciais",
  // Create Project Modal
  create_new_project: "Novo projeto",
  create_extracting: "Extraindo...",
  create_select_problems: "Selecionar problemas",
  create_select_topics: "Selecionar t\u00f3picos",
  create_new_video: "Novo v\u00eddeo",
  create_new_hw: "Novo projeto de tarefa",
  create_new_lecture: "Novo projeto de aula",
  create_new_self_study: "Novo Projeto",
  create_video: "V\u00eddeo",
  create_homework: "Tarefa",
  create_lecture: "Aula",
  create_self_study: "Projeto",
  create_video_sub: "Gerar um v\u00eddeo",
  create_hw_sub: "Enviar tarefa",
  create_lecture_sub: "Enviar slides",
  create_self_study_sub: "Escolha seus t\u00f3picos",
  create_video_prompt: "O que o v\u00eddeo deve explicar?",
  create_project_title: "T\u00edtulo do projeto",
  create_video_hint: "Isso ser\u00e1 usado como t\u00edtulo e como instru\u00e7\u00e3o para seu v\u00eddeo.",
  create_drop_hw: "Arraste sua tarefa aqui",
  create_drop_lecture: "Arraste seus slides aqui",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "Solte para iniciar um projeto",
  create_reading_hw: "Lendo sua tarefa",
  create_reading_lecture: "Lendo sua aula",
  create_finding_problems: "Buscando e extraindo problemas...",
  create_finding_topics: "Extraindo t\u00f3picos...",
  create_add_video: "Adicionar outro v\u00eddeo",
  create_add_more_files: "Adicionar mais arquivos",
  create_starting: "Iniciando gera\u00e7\u00e3o...",
  create_generate_video: "Gerar v\u00eddeo \u00B7 1 cr\u00e9dito",
  create_generate_n: "Gerar {n, plural, one {# v\u00eddeo} other {# v\u00eddeos}} \u00B7 {n, plural, one {# cr\u00e9dito} other {# cr\u00e9ditos}}",
  create_create_project: "Criar projeto \u00B7 {n, plural, one {# cr\u00e9dito} other {# cr\u00e9ditos}}",
  create_no_problems: "N\u00e3o foi poss\u00edvel encontrar problemas. Tente uma foto mais clara ou p\u00e1gina diferente.",
  create_no_topics: "N\u00e3o foi poss\u00edvel encontrar t\u00f3picos. Tente uma foto mais clara ou arquivo diferente.",
  create_error: "Algo deu errado. Por favor, tente novamente.",
  create_extract_daily_limit: "Esses são todos os documentos de hoje. Mais amanhã.",
  create_video_topic_placeholder: "T\u00f3pico do v\u00eddeo {n}, ex. \"Autovalores e autovetores\"",
  video_share: "Compartilhar",
  // and made the two indistinguishable.
  video_followup_placeholder: "Gerar vídeo de acompanhamento...",
  video_chip_simpler: "Explicar mais simples",
  video_chip_harder: "Exemplo mais dif\u00edcil",
  video_chip_real_world: "Uso no mundo real",
  // spends a credit generating a new one.
  video_ask_title: "Pergunte sobre este vídeo",
  video_ask_cta: "Converse sobre isso",
  video_ask_placeholder: "Faça uma pergunta...",
  video_ask_thinking: "Pensamento...",
  video_ask_close: "Fechar",
  video_ask_chip_explain: "Explique essa parte",
  video_ask_chip_example: "Dê um exemplo",
  video_ask_chip_why: "Por que isso funciona?",
  video_ask_limit_reached: "Você atingiu o limite de perguntas de hoje. Ele reinicia amanhã.",
  video_up_next: "A seguir",
  video_no_suggested: "Nenhum v\u00eddeo sugerido ainda",
  video_untitled: "V\u00eddeo sem t\u00edtulo",
  video_created_recently: "Criado recentemente",
  video_just_now: "Agora mesmo",
  video_minutes_ago: "h\u00e1 {n, plural, one {# minuto} other {# minutos}}",
  video_hours_ago: "h\u00e1 {n, plural, one {# hora} other {# horas}}",
  video_days_ago: "h\u00e1 {n, plural, one {# dia} other {# dias}}",
  video_weeks_ago: "h\u00e1 {n, plural, one {# semana} other {# semanas}}",
  video_months_ago: "h\u00e1 {n, plural, one {# m\u00eas} other {# meses}}",
  video_years_ago: "h\u00e1 {n, plural, one {# ano} other {# anos}}",
  video_unknown_date: "Data desconhecida",
  video_download_error: "Algo deu errado. Por favor, tente novamente.",
  // Search Results
  search_no_results: "Nenhum resultado encontrado",
  search_no_results_for: "Nenhum resultado encontrado para \"{query}\"",
  search_all_videos: "Buscar todos os v\u00eddeos",
  search_enter_term: "Digite um termo de busca para encontrar v\u00eddeos",
  search_retry: "Tentar novamente",
  auth_continue_google: "Continuar com Google",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "Inicie meu acesso imediatamente. Entendo que isso significa que renuncio ao meu direito de {days} dias de retirada e recebimento de reembolso.",
  home_sub_waiver_required: "Por favor, confirme isso para continuar.",
  home_sub_agree_prefix: "Ao continuar, você concorda com nossos",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "Você deve ter {age} ou mais para usar o Magi.",
  auth_agree_prefix: "Ao entrar, voc\u00ea concorda com nossos ",
  auth_terms: "Termos de servi\u00e7o",
  auth_and: " e ",
  auth_privacy: "Pol\u00edtica de privacidade",
  auth_email_optin: "Envie-me dicas e atualizações",
  // Auth modal (Google + email/password)
  auth_signin_title: "Faça login no Magi",
  auth_signin_desc: "Continue de onde parou.",
  auth_signup_title: "Crie sua conta",
  auth_signup_desc: "Gratuito para começar, não é necessário cartão.",
  auth_or: "ou",
  auth_continue_email: "Continuar com e-mail",
  auth_signing_in: "Fazendo login…",
  auth_working: "Só um segundo…",
  auth_email_placeholder: "Endereço de email",
  auth_password_placeholder: "Senha",
  auth_signin_submit: "Entrar",
  auth_signup_submit: "Criar uma conta",
  auth_no_account: "Novo aqui?",
  auth_signup_link: "Crie uma conta",
  auth_have_account: "Já tem uma conta?",
  auth_signin_link: "Entrar",
  auth_forgot_password: "Esqueceu sua senha?",
  auth_reset_title: "Redefinir sua senha",
  auth_reset_desc: "Enviaremos a você por e-mail um link para definir um novo.",
  auth_reset_submit: "Enviar link de redefinição",
  auth_reset_sent: "Verifique seu e-mail para obter o link de redefinição.",
  auth_back_to_signin: "Voltar para fazer login",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "Confirme seu e-mail para continuar",
  verify_wall_desc: "Enviamos um link de confirmação para {email}. Clique nele e volte aqui.",
  verify_wall_check: "eu confirmei",
  verify_wall_checking: "Verificando...",
  verify_wall_still_unverified: "Ainda não confirmado. Clique no link do e-mail e tente novamente.",
  verify_wall_resend: "Envie o link novamente",
  verify_wall_resent: "Enviado. Verifique sua caixa de entrada e sua pasta de spam.",
  verify_wall_wrong_account: "Conta errada? sair",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "Confirmando seu e-mail",
  verify_action_working_desc: "Um momento.",
  verify_action_done_title: "Você está pronto",
  verify_action_done_desc: "Seu e-mail está confirmado. Bem-vindo ao Magi.",
  verify_action_done_cta: "Comece a aprender",
  verify_action_failed_title: "Esse link não funcionou",
  verify_action_failed_desc: "Pode já ter sido usado ou expirou. Volte e envie para si mesmo um novo.",
  verify_action_failed_cta: "Voltar ao Magi",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "Faça login para assistir",
  auth_watch_desc: "Crie uma conta gratuita para reproduzir este vídeo.",
  auth_watch_ready_title: "Seu vídeo está pronto",
  auth_watch_ready_desc: "Faça login para assistir – ele será salvo em sua conta.",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "Faça login para baixar",
  auth_download_desc: "Crie uma conta gratuita para salvar este vídeo.",
  auth_ask_title: "Faça login para perguntar",
  auth_ask_desc: "Crie uma conta gratuita para perguntar sobre este vídeo.",
  auth_browse_title: "Faça login para navegar",
  auth_browse_desc: "Crie uma conta gratuita para explorar todas as lições.",
  auth_workspace_title: "Faça login para ver seu trabalho",
  auth_workspace_desc: "Suas lições e projetos ficam em sua conta.",
  auth_generate_title: "Faça login para continuar criando",
  auth_generate_desc: "Contas gratuitas recebem um vídeo todos os dias.",
  video_restricted: "Este vídeo ainda não está disponível.",
  // Share sheet
  share_title: "Compartilhe este vídeo",
  share_desc_mobile: "Poste em sua história, envie para um amigo ou copie o link.",
  share_desc_desktop: "Copie o link ou baixe o vídeo para postar no seu telefone.",
  share_to_apps: "Compartilhe no Instagram e muito mais",
  share_copy_link: "Copiar link",
  share_copied: "Link copiado",
  share_download: "Baixar vídeo",
  share_preparing: "Preparando tudo…",
  share_watermark_note: "Os vídeos compartilhados incluem magiacademy.com",
  // Welcome Modal (post-signup)
  welcome_title: "Bem-vindo ao Magos",
  welcome_subtitle: "Você tem 4 vídeos gratuitos para começar.",
  welcome_optin_reward: "+1 vídeo grátis",
  welcome_continue: "Continuar",
  age_gate_continue: "Continuar",
  age_gate_saving: "Salvando...",
  // Landing Page
  landing_hero: "Digite um tópico.",
  landing_hero2: "Faça uma vídeo aula.",
  landing_subtitle: "Magi transforma qualquer assunto em um vídeo narrado e lindamente animado em minutos. Sem filmagem, sem edição, sem necessidade de experiência.",
  landing_signup_google: "Inscreva-se no Google",
  landing_signing_in: "Entrando...",
  landing_chat_bubble: "Como o GPS usa a relatividade?",
  landing_stats_title: "Aprovado por alunos em todo o mundo",
  landing_stat_videos: "Mais de 3.000",
  landing_stat_videos_desc: "Vídeos gerados",
  landing_stat_languages_desc: "Idiomas",
  landing_stat_speed: "~1 minuto",
  landing_stat_speed_desc: "Tempo de geração",
  landing_feature_lecture_title: "Deixe suas anotações de aula, obtenha vídeos",
  landing_feature_lecture_desc: "Carregue seus slides ou notas. Magi seleciona cada tópico e gera uma explicação em vídeo para cada um.",
  landing_feature_hw_title: "Preso na lição de casa? Faça upload.",
  landing_feature_hw_desc: "Elimine um conjunto de problemas e o Magi extrai cada problema e, em seguida, orienta você na solução em um vídeo passo a passo.",
  landing_feature_chat_title: "Faça perguntas enquanto assiste",
  landing_feature_chat_desc: "Cada vídeo vem com um tutor de IA com quem você pode conversar. Faça perguntas complementares, obtenha explicações mais detalhadas ou solicite um novo vídeo sobre uma parte específica que você deseja entender melhor.",
  landing_feature_lang_title: "Aprenda no seu idioma",
  landing_feature_lang_desc: "Magi gera vídeos em inglês, espanhol, hindi, chinês, japonês e muito mais. Digite seu tópico em qualquer idioma e receba uma lição totalmente narrada nesse idioma.",
  landing_cta_title: "Comece a aprender em segundos",
  landing_cta_google: "Continuar com o Google",
  // Onboarding Bubbles
  onboarding_step1: "Isso n\u00e3o \u00e9 um chatbot \u2014 digite um t\u00f3pico e eu vou gerar uma aula em v\u00eddeo completa para voc\u00ea!",
  onboarding_step2: "Ou arraste um PDF ou foto \u2014 vou transformar cada problema em uma solu\u00e7\u00e3o passo a passo em v\u00eddeo",
  onboarding_step3: "Clique em ir e seu v\u00eddeo entra na fila. Voc\u00ea pode continuar navegando enquanto ele renderiza!",
  onboarding_generating: "Esta é a sua lição sendo aprendida em alguns minutos. Continue navegando se quiser; ele pousará aqui quando estiver pronto.",
  onboarding_skip: "Pular",
  onboarding_next: "Pr\u00f3ximo",
  onboarding_done: "Entendi!",
  // Generating Cards Row
  generating_label: "Gerando",
  // Lecture Session (Self Study)
  lecture_loading: "Carregando...",
  lecture_fallback_title: "Aula",
  lecture_building: "Construindo v\u00eddeo...",
  lecture_building_time: "Isso geralmente leva 2-4 minutos",
  lecture_failed: "A gera\u00e7\u00e3o do v\u00eddeo falhou",
  lecture_no_video: "Nenhum v\u00eddeo ainda",
  lecture_followup: "Acompanhamento",
  lecture_now_playing: "Reproduzindo agora",
  lecture_tab_videos: "V\u00eddeos",
  lecture_tab_chat: "Chat",
  lecture_chat_empty: "Pergunte qualquer coisa sobre este t\u00f3pico",
  lecture_chat_chip1: "Explique de forma simples",
  lecture_chat_chip2: "D\u00ea um exemplo",
  lecture_chat_chip3: "Por que isso \u00e9 \u00fatil?",
  lecture_chat_placeholder: "Pergunte sobre este t\u00f3pico...",
  lecture_followup_placeholder: "Adicionar um v\u00eddeo de acompanhamento...",
  lecture_chat_error: "Desculpe, n\u00e3o consegui processar isso. Tente novamente.",
  lecture_chat_generic_error: "Algo deu errado. Tente novamente.",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "PDF do dever de casa",
  home_sc_hw_desc: "Faça upload de um conjunto de problemas e obtenha um vídeo resolvido para cada pergunta",
  home_sc_lecture_title: "PDF da palestra",
  home_sc_lecture_desc: "Transforme slides ou anotações em uma série de lições",
  home_sc_course_title: "Crie um curso",
  home_sc_course_desc: "Planeje uma sequência de aulas sobre um tópico",
  // Misc
  generic_error: "Algo deu errado. Por favor, tente novamente.",
  loading: "Carregando...",
};

export default pt;
